import { Component } from "@angular/core";

@Component({
    selector: 'app-powerbi',
    templateUrl: './powerbi.component.html'
})
export class PowerbiComponent {

}